
import img1 from '../images/slider/img-slider-3.jpg'
import img2 from '../images/slider/img-slider-4.jpg'
import img3 from '../images/slider/img-slider-5.jpg'
import avt1 from '../images/avatar/avt-8.jpg'
import avt2 from '../images/avatar/avt-9.jpg'
import avt3 from '../images/avatar/avt-10.jpg'
import avt4 from '../images/avatar/avt-11.jpg'

const dataSlider2 = [
    {
        title: "Explore and bid for NFTs in style",
        description: "BestBid is the world's first sealed bid NFT auction platform",
        img1: img1,
        img2: img2,
        img3: img3,
        avt1: avt1,
        avt2: avt2,
        avt3: avt3,
        avt4: avt4,
    },
]

export default dataSlider2;